import React, { useEffect, Suspense, lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { REDIRECTS } from './constants/redirects';
import Layout from './components/layout/Layout';
import AdminLayout from './components/admin/AdminLayout';
import AdminLogin from './components/admin/AdminLogin';
import AdminDashboard from './components/admin/AdminDashboard';
import AdminProducts from './components/admin/AdminProducts';
import AdminCategories from './components/admin/AdminCategories';
import AdminOrders from './components/admin/AdminOrders';
import AdminUsers from './components/admin/AdminUsers';
import AdminSettings from './components/admin/AdminSettings';
import AdminSEO from './components/admin/AdminSEO';
import HomePage from './pages/HomePage';
import KtpnPromoPage from './pages/KtpnPromoPage';
import CatalogPage from './pages/CatalogPage';
import TransformerListPage from './pages/catalog/TransformerListPage';
import TransformerDetailPage from './pages/catalog/TransformerDetailPage';
import KtpPage from './pages/catalog/KtpPage';
import KtpDetailPage from './pages/catalog/KtpDetailPage';
import SwitchgearPage from './pages/catalog/SwitchgearPage';
import CablePage from './pages/catalog/CablePage';
import KsoPage from './pages/catalog/KsoPage';
import TurnkeyPage from './pages/catalog/TurnkeyPage';
import ProductPage from './pages/ProductPage';
import AboutPage from './pages/AboutPage';
import AdvantagesPage from './pages/AdvantagesPage';
import EquipmentPage from './pages/EquipmentPage';
import ServicesPage from './pages/ServicesPage';
import ProjectsPage from './pages/ProjectsPage';
import FaqPage from './pages/FaqPage';
import OilToDryPage from './pages/OilToDryPage';
import SntPage from './pages/SntPage';
import KtpnKioskPage from './pages/KtpnKioskPage';
import Ktpn250Page from './pages/Ktpn250Page';
import Ktpn160Page from './pages/Ktpn160Page';
import Ktpn100Page from './pages/Ktpn100Page';
import BktpPage from './pages/BktpPage';
import NkuPage from './pages/NkuPage';
import KruPage from './pages/KruPage';
import TransformerCalculatorPage from './pages/TransformerCalculatorPage';
import ContactPage from './pages/ContactPage';
// import BlogPage from './pages/BlogPage'; // Old direct import
// import BlogPostPage from './pages/BlogPostPage'; // Old direct import
import NotFoundPage from './pages/NotFoundPage';
import { initGA, initYM } from './utils/analytics';
import { Clarity } from './components/analytics/Clarity';

const BlogPage = lazy(() => import('./pages/BlogPage'));
const BlogPostPage = lazy(() => import('./pages/BlogPostPage'));

function App() {
  useEffect(() => {
    // Инициализация Google Analytics
    const gaId = import.meta.env.VITE_GA_MEASUREMENT_ID;
    if (gaId) {
      initGA(gaId);
    }

    // Инициализация Яндекс.Метрики
    const ymId = import.meta.env.VITE_YM_COUNTER_ID;
    if (ymId) {
      initYM(Number(ymId));
    }
  }, []);

  return (
    <>
      <Clarity />
      <Routes>
        {/* Redirects */}
        {REDIRECTS.map(({ from, to }) => (
          <Route key={from} path={from} element={<Navigate to={to} replace />} />
        ))}

        {/* Admin Routes */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<AdminDashboard />} />
          <Route path="products" element={<AdminProducts />} />
          <Route path="categories" element={<AdminCategories />} />
          <Route path="orders" element={<AdminOrders />} />
          <Route path="users" element={<AdminUsers />} />
          <Route path="settings" element={<AdminSettings />} />
          <Route path="seo" element={<AdminSEO />} />
        </Route>

        {/* Public Routes */}
        <Route path="/" element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="ktpn" element={<KtpnPromoPage />} />
          <Route path="catalog" element={<CatalogPage />} />
          <Route path="catalog/transformers" element={<TransformerListPage />} />
          <Route path="catalog/transformers/:slug" element={<TransformerDetailPage />} />
          <Route path="catalog/ktp" element={<KtpPage />} />
          <Route path="catalog/ktp/:type" element={<KtpDetailPage />} />
          <Route path="catalog/switchgear" element={<SwitchgearPage />} />
          <Route path="catalog/cable" element={<CablePage />} />
          <Route path="catalog/kso" element={<KsoPage />} />
          <Route path="catalog/turnkey" element={<TurnkeyPage />} />
          <Route path="catalog/:category/:id" element={<ProductPage />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="advantages" element={<AdvantagesPage />} />
          <Route path="equipment" element={<EquipmentPage />} />
          <Route path="services" element={<ServicesPage />} />
          <Route path="projects" element={<ProjectsPage />} />
          <Route path="faq" element={<FaqPage />} />
          <Route path="contact" element={<ContactPage />} />
          <Route path="calculator" element={<TransformerCalculatorPage />} />
          <Route path="replacement" element={<OilToDryPage />} />
          <Route path="snt" element={<SntPage />} />
          <Route path="ktpn-kiosk" element={<KtpnKioskPage />} />
          <Route path="ktpn-250" element={<Ktpn250Page />} />
          <Route path="ktpn-160" element={<Ktpn160Page />} />
          <Route path="ktpn-100" element={<Ktpn100Page />} />
          <Route path="bktp" element={<BktpPage />} />
          <Route path="nku" element={<NkuPage />} />
          <Route path="kru" element={<KruPage />} />
          <Route
            path="blog/category/:categorySlug"
            element={
              <Suspense fallback={<div>Загрузка блога...</div>}>
                <BlogPage />
              </Suspense>
            }
          />
          <Route
            path="blog/:slug"
            element={
              <Suspense fallback={<div>Загрузка статьи...</div>}>
                <BlogPostPage />
              </Suspense>
            }
          />
          <Route
            path="blog"
            element={
              <Suspense fallback={<div>Загрузка блога...</div>}>
                <BlogPage />
              </Suspense>
            }
          />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
